import { Spin } from 'antd'
import React from 'react'

function Loading() {
  return (<Spin spinning className='w-full h-[90vh] bg-white flex justify-center items-center rounded-xl shadow-xl text-primary' size="large" />)
}

export default Loading